import { render } from "./CertificateType.vue?vue&type=template&id=35fd6ac6&scoped=true"
import script from "./CertificateType.vue?vue&type=script&lang=js"
export * from "./CertificateType.vue?vue&type=script&lang=js"

import "./CertificateType.vue?vue&type=style&index=0&id=35fd6ac6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fd6ac6"]])

export default __exports__